import UserDatalayer from '@curry/user'

export default class UserApi {
  constructor({ config, transports }) {
    this.datalayer = new UserDatalayer({ config, transports });
  }
  
  view() {
    return new Promise((resolve, reject) => {
      const args = { };
      this.datalayer.models[0].findById({ 
        args 
      }).then((response) => {
        resolve(response.data); 
      }).catch(reject);
    });
  }

  put({ user }) {
    return new Promise((resolve, reject) => {
      if(user === null) {
        resolve();  
      }
      
      this.datalayer.models[0].update({ 
        item: user
      }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }

  comment({ orderId, comment }) {
    return new Promise((resolve, reject) => {      
      const args = { order_id: orderId, comment };

      this.datalayer.models[0].save({ 
        args,
        item: { comment }
      }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }

  setLang({ locale }) {
    return new Promise((resolve, reject) => {
      const args = {};
      const item = { locale };
      this.datalayer.models[0].setLang({
        args, 
        item
      }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }
}